import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import './SignatureModal.scss';

export class SignatureModal extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {clickToSign: props.propClickToSign, signing: false};
        this.i = 0;
    }

    typeWriter = () => {

        let $sign = document.getElementById('signature');
        this.setState({clickToSign: false, signing: true});

        if (this.i < this.props.name.length) {
            $sign.innerHTML += this.props.name.charAt(this.i);
            this.i++;
            setTimeout(this.typeWriter, 150);
        } else {
            this.props.hasSubmitted(false);
            this.setState({signing: false});
            this.props.submitPolicies();
        }
    };

    closeModal = () => {
        this.setState({clickToSign: true});
        document.getElementById('signature').innerHTML = '';
        this.i = 0;
        this.props.handleClose();
    };

    render() {
        const {name, countryName, show, roleName} = this.props;

        return (
            <div className={show ? "modal display-block" : "modal display-none"}>
                <div className="modal-main">
                    <div className="container p4">
                        <div className="align-c pb2">
                            {this.props.roleName === "Prime Minister"
                                ?
                                <Fragment>
                                <h1>Press Release</h1>
                                    <p>In my role as Prime Minister, relying on my own knowledge and judgment, as
                                        well as in consultation with experts in the relevant fields, I have come to
                                        the conclusion that the attached are the best possible policies for our
                                        nation at the current time.</p>
                                    <p>I hereby implement these policies for the betterment of my country.</p>
                                </Fragment>
                                : this.props.roleName.includes('ATG')
                                    ?
                                    <Fragment>
                                        <h1>Policy Proposal</h1>
                                        <p> In my role as Delegate to the Altrippa Treaty Group, representing my
                                            country’s government and its citizens, relying on my own knowledge and
                                            judgment as well as in consultation with experts in the relevant fields, I
                                            have come to the conclusion that the attached are the best possible policies
                                            for our region at the current time.</p>
                                        <p>I hereby submit these proposals for consideration by the Administration of
                                            the President of the Altrippa Treaty Group.</p>
                                    </Fragment>
                                    :
                                    <Fragment>
                                        <h1>Policy Proposal</h1>
                                        <p>In my role as Cabinet Minister, relying on my own knowledge and judgment, as
                                            well as in consultation with experts in the relevant fields, I have come to
                                            the conclusion that the attached are the best possible policies for our
                                            nation at the current time.</p>
                                        <p>I hereby submit these proposals with humility and hope to the government of
                                            the Honorable Prime Minister for consideration.</p>
                                    </Fragment>
                            }
                        </div>

                        <div id="signature"/>
                        {
                            this.state.clickToSign &&
                            <button id="sign" className="button" onClick={this.typeWriter}>
                                Sign and Apply
                            </button>
                        }
                        <div id="name">{name}</div>
                        <div>{roleName} of {countryName}</div>


                        {!this.state.signing && <div className="close-article" onClick={this.closeModal}/>}
                    </div>
                </div>
            </div>
        );
    };
}

SignatureModal.propTypes = {
    show: PropTypes.bool.isRequired,
    propClickToSign: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    hasSubmitted: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    countryName: PropTypes.string.isRequired,
    roleName: PropTypes.string.isRequired,
    submitPolicies: PropTypes.func.isRequired,
};

export default SignatureModal;
